import React from "react";
import PageHeader from "../../components/PageHeader";
import NewsCategoryListComponent from "../../components/NewsCategory/NewsCategoryList";

class NewsCategoryList extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="News Categories"
                            Breadcrumb={[
                                { name: "News Categories", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <NewsCategoryListComponent />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default NewsCategoryList;
